import { ReactNode } from 'react'

import { Form } from 'factorial-form'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { formGetDirtyFields } from 'modules/core/lib/formGetDirtyFields'

import ContractFlowStep from 'modules/contracts/lib/ContractFlowStep'

class PromoteFlowStep extends ContractFlowStep {
  constructor(title: string, component: ReactNode, description?: string) {
    super(title, component, description)
  }

  trackNext(form: Form, step: number): void {
    track(trackingEvents.employee.contracts.promoteContractNext, {
      step: step,
      fields_edited: formGetDirtyFields(form),
      fields_completed: form.fieldsWithValueKeys,
      approval: false,
    })
  }

  trackBack(form: Form, step: number): void {
    track(trackingEvents.employee.contracts.promoteContractBack, {
      step: step,
      fields_edited: formGetDirtyFields(form),
      fields_completed: form.fieldsWithValueKeys,
    })
  }

  trackSubmit(form: Form): void {
    track(trackingEvents.employee.contracts.promoteContractSubmit, {
      fields_edited: formGetDirtyFields(form),
      fields_completed: form.fieldsWithValueKeys,
      approval: false,
    })
  }

  trackExit(step: number): void {
    track(trackingEvents.employee.contracts.promoteContractExit, {
      step: step,
    })
  }
}

export default PromoteFlowStep
